import React from 'react'

import Component from './component'

const Container = ({ mode, expandedSections }) => {

  const mergedProps = {
    expandedSections,
    mode
  }

  return (
    <Component {...mergedProps} />
  )
}

export default Container
